<template>
  <div>
    <m-row v-if="field">
      <m-col lg="4">{{ translated_name }}</m-col>
      <m-col lg="4">
        <memlist-checkbox 
          v-model="local_show"
          @input="input_show"
        />
      </m-col>
      <m-col lg="4">
        <memlist-checkbox 
          v-model="local_requirement"
          @input="input_requirement"
        />
      </m-col>
    </m-row>
  </div>
</template>


<script>


import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';

import axios from 'axios';
import dayjs from 'dayjs';


export default {

  text: 'FormPagePersonDetailsRequirementRow',

  props: ['field','name'],
  emits: ['change'],
  mixins: [ toasts ],

  components: {
    
  },

  watch: {
    
    field: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_show = val.show;
        this.local_requirement = val.requirement;
      },
      immediate: true
    },
  },

  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId']),
    translated_name() {
      return this.$t('MEMBER.'+this.name.toUpperCase());
    }
  },

  async mounted() {

  },

  methods: {

    input_requirement(val) {
      this.$emit('change', { name: this.name, show: this.local_show, requirement: val });
    },
    input_show(val) {
      this.$emit('change', { name: this.name, show: val, requirement: this.local_requirement });
    },
    
  },


  data() {
    return {
      local_show: false,
      local_requirement: false
    };
  }
};

</script>

<style lang="scss" scoped>
@import "@/assets/sass/components/forms/_compact.scss";
</style>
